import { render, staticRenderFns } from "./recomDetail.vue?vue&type=template&id=6bc66416&scoped=true&"
import script from "./recomDetail.vue?vue&type=script&lang=js&"
export * from "./recomDetail.vue?vue&type=script&lang=js&"
import style0 from "./recomDetail.vue?vue&type=style&index=0&id=6bc66416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc66416",
  null
  
)

export default component.exports